<div class="flex w-full h-full">
  <!-- Panel de gauche -->
  <div class="forms-wrapper flex flex-col w-[320px] min-w-[320px]">
    <!-- Calendrier -->
    <p-card styleClass="mb-2" class="card-custom calendar-card">
      <ng-template pTemplate="header">
        <div class="p-1 bg-neutral-900 flex items-center">
          <i class="pi pi-calendar mr-2"></i>
          <h3 class="text-base m-0">Période</h3>
        </div>
      </ng-template>
      <div
        class="p-1 week-clickable-calendar"
        (click)="onCalendarClick($event)"
      >
        <p-datepicker
          #weekPickerCalendar
          [inline]="true"
          [formControl]="rangeDates"
          selectionMode="range"
          [readonlyInput]="true"
          styleClass="w-full compact-calendar"
          [showTime]="false"
          dateFormat="dd/mm/yy"
          [firstDayOfWeek]="1"
          [showWeek]="true"
        ></p-datepicker>
      </div>
    </p-card>

    <!-- Produits à programmer -->
    <p-card styleClass="mb-2" class="card-custom">
      <ng-template pTemplate="header">
        <div class="p-1 bg-neutral-900 flex items-center justify-between">
          <div class="flex items-center">
            <i class="pi pi-box mr-2"></i>
            <h3 class="text-base m-0">Produits à programmer</h3>
          </div>
        </div>
      </ng-template>

      <div class="p-1">
        <div id="external-events" class="flex flex-col gap-1">
          <!-- Message d'instruction -->
          <!-- Message d'instruction - visible uniquement s'il y a des produits à programmer -->
          @if (unscheduledProductGroups.length || unscheduledProducts.length) {
            <div class="text-xs text-center text-neutral-400 p-2 mb-2">
              <i class="pi pi-info-circle mr-1"></i>
              Glisser les produits sur le calendrier pour les planifier
            </div>
          }

          <!-- Afficher les groupes de produits non programmés s'ils existent -->
          @if (unscheduledProductGroups.length) {
            <div>
              @for (group of unscheduledProductGroups; track group.id) {
                <div
                  class="product-group-item border border-neutral-700 p-2 rounded-lg mb-2"
                  [class.disabled-product]="hasSingleProductDropped"
                  [attr.data-products]="getProductIdsString(group.products)"
                  [attr.data-group-name]="group.productsNames"
                  [attr.data-group-id]="group.id || group.group"
                  [attr.data-is-manual]="group.id ? 'true' : 'false'"
                  [attr.draggable]="!hasSingleProductDropped"
                >
                  <div class="flex justify-between items-center">
                    <span class="text-sm font-medium">{{
                      group.productsNames
                    }}</span>
                    <span class="text-xs bg-neutral-900 px-2 py-1 rounded">
                      {{ group.totalDuration }} min
                    </span>
                  </div>
                  <p class="text-xs text-neutral-400 mt-1">
                    {{ group.products.length }} produits
                  </p>

                  @if (hasSingleProductDropped) {
                    <div class="text-xs text-amber-500 opacity-75 mt-1">
                      <i class="pi pi-lock mr-1"></i>Désactivé
                    </div>
                  }
                </div>
              }
            </div>
          }
          <!-- Afficher les produits individuels non programmés UNIQUEMENT si aucun groupe n'existe -->
          @else if (unscheduledProducts.length) {
            <div>
              <h4 class="text-sm font-semibold text-neutral-400 mb-1">
                Produits individuels
              </h4>
              @for (product of unscheduledProducts; track product.id) {
                <div
                  class="product-item border p-2 rounded-lg mb-1"
                  [class.disabled-product]="hasSingleProductDropped"
                  [attr.data-product]="product.id"
                  [attr.draggable]="!hasSingleProductDropped"
                >
                  <div class="flex justify-between items-center">
                    <span class="text-sm font-medium">{{
                      product.product?.name || 'Produit'
                    }}</span>
                    <span class="text-xs bg-neutral-800 px-2 py-1 rounded">
                      {{ product.product?.duration || 0 }} min
                    </span>
                  </div>
                  <p class="text-xs text-neutral-400 mt-1 ml-2">
                    {{
                      product.orderId ||
                        product.product?.reference ||
                        'Référence N/A'
                    }}
                  </p>
                </div>
              }
            </div>
          } @else {
            <!-- Message si tous les produits sont programmés ou aucun produit disponible -->
            @if (selectedProducts.length || productGroups.length) {
              <p class="text-xs text-center text-green-500 p-2">
                <i class="pi pi-check-circle mr-1"></i>
                Tous les produits ont été programmés
              </p>
            } @else {
              <p class="text-xs text-center text-neutral-400 p-2">
                Aucun produit à programmer
              </p>
            }
          }
        </div>
      </div>
    </p-card>
  </div>

  <p-divider layout="vertical" styleClass="mx-1"></p-divider>

  <!-- Zone du calendrier FullCalendar -->
  <div class="flex-1 calendar-area flex flex-col">
    <!-- Nouvelle section: En-tête du calendrier avec date actuelle et navigation -->
    <div
      class="calendar-header bg-neutral-800 p-2 border-b border-neutral-700 flex items-center justify-between"
    >
      <div class="flex items-center">
        <h4 class="text-sm font-medium m-0 mr-4">
          <i class="pi pi-calendar mr-2"></i> Planning
        </h4>
        <!-- Si aucun technicien n'est sélectionné, afficher un message -->
        @if (!selectedTechnicians.length) {
          <div class="text-xs text-neutral-400">
            Sélectionnez un technicien pour voir les itinéraires
          </div>
        } @else if (selectedTechnicians.length === 1) {
          <!-- Si un seul technicien est sélectionné, montrer ses liens d'itinéraire -->
          <div class="route-links flex items-center gap-1">
            <span class="text-xs text-neutral-400 mr-1">Itinéraires:</span>
            @for (day of getWeekDays(); track $index) {
              <button
                type="button"
                class="route-day-link text-xs px-2 py-1 rounded cursor-pointer flex flex-col items-center"
                [ngClass]="{
                  'bg-blue-900 hover:bg-blue-800':
                    day.isToday && day.hasInterventions,
                  'bg-neutral-700 hover:bg-neutral-600':
                    !day.isToday && day.hasInterventions,
                  'bg-neutral-800 opacity-50 cursor-not-allowed':
                    !day.hasInterventions,
                }"
                [title]="
                  day.hasInterventions
                    ? 'Itinéraire du ' +
                      day.longFormat +
                      ' pour ' +
                      selectedTechnicians[0].firstname
                    : 'Aucune intervention programmée pour ' +
                      selectedTechnicians[0].firstname +
                      ' le ' +
                      day.longFormat
                "
                (click)="openDailyRouteUrl(selectedTechnicians[0], day.date)"
              >
                <span>{{ day.shortName }}</span>
                <span class="text-[10px] opacity-80">{{
                  day.date | date: 'dd'
                }}</span>
                <span
                  class="text-[8px] text-green-400 font-bold"
                  *ngIf="day.hasInterventions"
                >
                  {{ day.interventionCount }}
                </span>
              </button>
            }
          </div>
        } @else {
          <!-- Si plusieurs techniciens sont sélectionnés, montrer un sélecteur de technicien -->
          <div class="flex items-center gap-2">
            <div class="text-xs">Itinéraires pour</div>
            <div class="tech-selector flex gap-1">
              @for (tech of selectedTechnicians; track tech.id) {
                <div
                  class="tech-avatar w-6 h-6 rounded-full flex items-center justify-center cursor-pointer border-2"
                  [style.background-color]="tech.color || '#666'"
                  [style.border-color]="
                    selectedTechForRoutes?.id === tech.id
                      ? '#fff'
                      : 'transparent'
                  "
                  [title]="tech.firstname + ' ' + tech.lastname"
                  (click)="selectTechnicianForRoutes(tech)"
                >
                  <span class="text-white text-xs">{{
                    getTechnicianInitials(tech)
                  }}</span>
                </div>
              }
            </div>

            <!-- Afficher les liens pour le technicien sélectionné -->
            @if (selectedTechForRoutes) {
              <div class="route-links flex items-center gap-1 ml-2">
                <span class="text-xs text-neutral-400 mr-1">Itinéraires:</span>
                @for (day of getWeekDays(); track $index) {
                  <button
                    type="button"
                    class="route-day-link text-xs px-2 py-1 rounded cursor-pointer flex flex-col items-center"
                    [ngClass]="{
                      'bg-blue-900 hover:bg-blue-800':
                        day.isToday && day.hasInterventions,
                      'bg-neutral-700 hover:bg-neutral-600':
                        !day.isToday && day.hasInterventions,
                      'bg-neutral-800 opacity-50 cursor-not-allowed':
                        !day.hasInterventions,
                    }"
                    [title]="
                      day.hasInterventions
                        ? 'Itinéraire du ' +
                          day.longFormat +
                          ' pour ' +
                          selectedTechForRoutes.firstname
                        : 'Aucune intervention programmée pour ' +
                          selectedTechForRoutes.firstname +
                          ' le ' +
                          day.longFormat
                    "
                    (click)="openDailyRouteUrl(selectedTechForRoutes, day.date)"
                  >
                    <span>{{ day.shortName }}</span>
                    <span class="text-[10px] opacity-80">{{
                      day.date | date: 'dd'
                    }}</span>
                    <span
                      class="text-[8px] text-green-400 font-bold"
                      *ngIf="day.hasInterventions"
                    >
                      {{ day.interventionCount }}
                    </span>
                  </button>
                }
              </div>
            }
          </div>
        }
      </div>
      <div class="view-options flex gap-1">
        <button
          type="button"
          class="refresh-btn text-xs px-2 py-1 rounded cursor-pointer bg-green-700 hover:bg-green-600"
          [disabled]="loadingEvents"
          (click)="forceRefreshEvents()"
          title="Actualiser les interventions et événements"
        >
          <i class="pi pi-refresh" [ngClass]="{ 'pi-spin': loadingEvents }"></i>
        </button>
        <button
          type="button"
          class="view-option text-xs px-2 py-1 rounded cursor-pointer"
          [ngClass]="{
            'bg-blue-900 hover:bg-blue-800': currentView === 'dayGridMonth',
            'bg-neutral-700 hover:bg-neutral-600':
              currentView !== 'dayGridMonth',
          }"
          (click)="changeCalendarView('dayGridMonth')"
          title="Vue mensuelle"
        >
          <i class="pi pi-calendar"></i> Mois
        </button>
        <button
          type="button"
          class="view-option text-xs px-2 py-1 rounded cursor-pointer"
          [ngClass]="{
            'bg-blue-900 hover:bg-blue-800': currentView === 'timeGridWeek',
            'bg-neutral-700 hover:bg-neutral-600':
              currentView !== 'timeGridWeek',
          }"
          (click)="changeCalendarView('timeGridWeek')"
          title="Vue hebdomadaire"
        >
          <i class="pi pi-calendar-plus"></i> Semaine
        </button>
        <button
          type="button"
          class="view-option text-xs px-2 py-1 rounded cursor-pointer"
          [ngClass]="{
            'bg-blue-900 hover:bg-blue-800': currentView === 'timeGridDay',
            'bg-neutral-700 hover:bg-neutral-600':
              currentView !== 'timeGridDay',
          }"
          (click)="changeCalendarView('timeGridDay')"
          title="Vue journalière"
        >
          <i class="pi pi-calendar-minus"></i> Jour
        </button>
      </div>
    </div>

    <div class="w-full flex-grow relative">
      @if (loadingEvents) {
        <div
          class="absolute inset-0 flex justify-center items-center bg-neutral-900 bg-opacity-70 z-10"
        >
          <p-progressSpinner [style]="{ width: '50px', height: '50px' }" />
        </div>
      }

      <full-calendar
        [options]="calendarOptions"
        [events]="fullCalendarEvents$ | async"
        (contextmenu)="onCalendarContextMenu($event)"
      ></full-calendar>
    </div>
  </div>
</div>

<!-- Menu contextuel -->
<p-contextMenu #contextMenu [model]="contextMenuItems"></p-contextMenu>
